import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import notificationsPlugin from '@backstage/plugin-notifications/alpha';
import signalsPlugin from '@backstage/plugin-signals/alpha';
import { authModule } from './modules/auth';
import { cliAuthPlugin } from './modules/cli-auth';
import { navModule } from './modules/nav';
import { catalogModule } from './modules/catalog';
import { doraPlugin } from './modules/dora';
import { kafkaPlugin } from './modules/kafka';
import { externalToolsPlugin } from './modules/external-tools';
import { githubPullRequestsPlugin } from './modules/github';
import { approvalsPlugin } from './modules/approvals';
import { searchPlugin } from './modules/search';
import { homePlugin } from './modules/home';
import { kubernetesOverviewPlugin } from './modules/kubernetes';
import { regaskNotificationsPlugin } from './modules/notifications';
import { actionsPlugin } from './modules/actions';
import { securityInsightsPlugin } from './modules/security';
import { regaskSentryPlugin } from './modules/sentry';
import { techInsightsModule } from './modules/tech-insights';
import { settingsModule } from './modules/settings';
import { themeModule } from './modules/theme';
import { templatesModule } from './modules/templates';
import { configurationModule } from './modules/configuration';
import { adminPlugin } from './modules/admin';
import { helpPlugin } from './modules/help';
import { usvcMigrationsPlugin } from './modules/usvcMigrations';
import { deploymentsPlugin } from './modules/deployments';
import { queryPlugin } from './modules/query';

export default createApp({
  features: [
    catalogPlugin,
    notificationsPlugin,
    signalsPlugin,
    authModule,
    cliAuthPlugin,
    navModule,
    catalogModule,
    doraPlugin,
    kafkaPlugin,
    usvcMigrationsPlugin,
    deploymentsPlugin,
    queryPlugin,
    scaffolderPlugin,
    templatesModule,
    configurationModule,
    externalToolsPlugin,
    githubPullRequestsPlugin,
    approvalsPlugin,
    searchPlugin,
    adminPlugin,
    helpPlugin,
    homePlugin,
    kubernetesOverviewPlugin,
    regaskNotificationsPlugin,
    actionsPlugin,
    securityInsightsPlugin,
    regaskSentryPlugin,
    techInsightsModule,
    settingsModule,
    themeModule,
  ],
});
